import { render } from "./MultipleChoiceInput.vue?vue&type=template&id=ce59c67c&ts=true"
import script from "./MultipleChoiceInput.vue?vue&type=script&lang=ts"
export * from "./MultipleChoiceInput.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/stamincasa/stamincasa-matematica/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__